import apiClient from '../helpers/ApiClient'
import { authHeader, handleError } from '../helpers/ApiClient';
import imageCompression from "browser-image-compression";


export const imageService = {
    uploadImage,
    uploadIconImage,
    getAllImages,
    deleteImage,
    onImageUploaded
}

let uploadListener = null;

function onImageUploaded(listener) {
    uploadListener = listener;
}

const S3_ENV_HEADER_VALUES = {
    production: 'production',
    development: 'staging',
    blackbox: 'blackbox',
    'blackbox-staging': 'blackbox-staging',
};

function s3EnvHeader() {
    const value = S3_ENV_HEADER_VALUES[process.env.NODE_ENV];
    return value ? { 'x-amz-meta-env': value } : {};
}

// Function to get a presigned URL
async function getPresignedUrl(filename, customFolder = null) {
    try {
        const params = { fileName: filename };
        if (customFolder) {
            params.customFolder = customFolder;
        }
        const response = await apiClient.get("/image/presign", {
            params,
            headers: authHeader(),
        });
        console.log('response', response);
        return response.data.data.presignedURL;
    } catch (error) {
        console.log('error', error);
        return await handleError(error);
    }
}

// Icons (product pictos) are global: stored under the shared "icons/" S3 prefix,
// no org metadata and no compression (SVG files must stay untouched)
async function uploadIconImage(file) {
    try {
        const presignedUrl = await getPresignedUrl(file.name, "ICONS");
        const fileUrl = presignedUrl.split('?')[0];

        await apiClient.put(presignedUrl, file, {
            headers: {
                'Content-Type': file.type,
                ...s3EnvHeader(),
            },
        });

        return fileUrl;
    } catch (error) {
        return await handleError(error);
    }
}


async function uploadImage(file, orgId, maxSize = 0.2, maxWidth = 300, compressFile = true) {
    try {
        const type = localStorage.getItem('orgType');

        const options = {
            useWebWorker: true,
            maxSizeMb: maxSize
        }

        if (type === "RETAIL"){
            options.maxWidthOrHeight = 700
        }else{
            options.maxWidthOrHeight = maxWidth;
        }

        if (maxWidth === 1920){
            options.maxWidthOrHeight = maxWidth
        }

        let compressedFile = file
        if (compressFile){
            compressedFile = await imageCompression(file, options);
        }
        const presignedUrl = await getPresignedUrl(file.name);
        const fileUrl = presignedUrl.split('?')[0];

        await apiClient.put(presignedUrl, compressedFile, {
            headers: {
                'Content-Type': compressedFile.type,
                'x-amz-meta-orgid': orgId,
                ...s3EnvHeader(),
            },
        });

        uploadListener?.();
        return fileUrl;
    } catch (error) {
        return await handleError(error);
    }
}

function getAllImages() {
    return apiClient
        .get('/image', {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function deleteImage(imageId) {
    return apiClient
        .delete(`/image/${imageId}`, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}




